import { BusinessOnboardingDetails } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import {
  BusinessAddressDetailsFormSchema,
  BusinessAddressDetailsFormType,
} from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessAddressDetails/schemas/BusinessAddressDetailsFormSchema';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { ADDRESS_BLANK_VALUES } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/constants/AddressBlankValues';
import { AddressMap } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/maps/address.map';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { removeNullKeysFromObject } from '@/utils/removeNullKeysFromObject';

import { BusinessAddressDetailsForm } from './BusinessAddressDetailsForm';
interface BusinessAddressDetailsEditDialogProps {
  businessDetails: BusinessOnboardingDetails;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  setBusinessDetailsToOnboardingDetails: (data) => void;
  loading?: boolean;
}

export const BusinessAddressDetailsEditDialog = ({
  businessDetails,
  opened,
  setOpened,
  toggleDialog,
  setBusinessDetailsToOnboardingDetails,
  loading,
}: BusinessAddressDetailsEditDialogProps) => {
  const businessDetailsValues = businessDetails.businessDetails;

  const businessAddressDetailsDefaultValues = {
    businessAddress: businessDetailsValues?.address
      ? AddressMap.toForm(businessDetailsValues.address)
      : ADDRESS_BLANK_VALUES,
  };

  const onSubmitForm = async (formValues: BusinessAddressDetailsFormType) => {
    const onboardingDetails = {
      ...businessDetailsValues,
      id: businessDetails.id,
      address: AddressMap.toDto(formValues.businessAddress),
    };
    await setBusinessDetailsToOnboardingDetails(removeNullKeysFromObject(onboardingDetails));
    toggleDialog();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      onSubmitForm={onSubmitForm}
      title={'EDIT_BUSINESS_ADDRESS'}
      isLoading={loading}
      defaultValues={businessAddressDetailsDefaultValues}
      formSchema={BusinessAddressDetailsFormSchema}
    >
      <BusinessAddressDetailsForm
        businessDetails={businessDetails.businessDetails}
        fullWidth={true}
        fieldVariant={FieldVariant.form}
      />
    </EditDialogWrapper>
  );
};
